/* showroom-booking — alegi ziua, alegi ora, pleci pe WhatsApp cu mesajul scris.
   Fara backend deliberat: nu stocam programari, deci nu putem verifica daca un
   interval e liber. Textul spune "cerere", iar confirmarea o da omul pe WhatsApp.
   Daca vreodata devine prea aglomerat ca sa mearga asa, atunci merita un backend —
   nu inainte. */
(function () {
  'use strict';

  var ZILE = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];
  var LUNI = ['ian', 'feb', 'mar', 'apr', 'mai', 'iun', 'iul', 'aug', 'sep', 'oct', 'noi', 'dec'];

  function init(root) {
    var daysEl = root.querySelector('[data-shb-days]');
    var slotsEl = root.querySelector('[data-shb-slots]');
    var goEl = root.querySelector('[data-shb-go]');
    var sumEl = root.querySelector('[data-shb-sum]');
    if (!daysEl || !slotsEl || !goEl) return;

    var cfg = {
      phone: root.getAttribute('data-phone') || '',
      open: parseInt(root.getAttribute('data-open'), 10) || 9,
      close: parseInt(root.getAttribute('data-close'), 10) || 18,
      step: parseInt(root.getAttribute('data-step'), 10) || 30,
      lead: parseInt(root.getAttribute('data-lead'), 10) || 2,      // ore de preaviz
      horizon: parseInt(root.getAttribute('data-horizon'), 10) || 14,
      workdays: (root.getAttribute('data-workdays') || '1,2,3,4,5,6').split(',').map(Number)
    };

    var sel = { day: null, time: null };

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function buildDays() {
      var now = new Date();
      var made = 0;
      for (var i = 0; i < cfg.horizon && made < 10; i++) {
        var d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
        if (cfg.workdays.indexOf(d.getDay()) === -1) continue;
        if (!slotsFor(d).length) continue;   // azi, daca s-au dus toate orele
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'shb__day';
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('data-iso', d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()));
        b.innerHTML = '<span class="shb__day-dow">' + (i === 0 ? 'azi' : ZILE[d.getDay()].slice(0, 3)) + '</span>' +
                      '<span class="shb__day-num">' + d.getDate() + '</span>' +
                      '<span class="shb__day-mon">' + LUNI[d.getMonth()] + '</span>';
        b.addEventListener('click', function (ev) { pickDay(ev.currentTarget); });
        daysEl.appendChild(b);
        made++;
      }
      if (made) pickDay(daysEl.firstChild);
      else slotsEl.innerHTML = '<p class="shb__empty">Momentan nu avem intervale libere. Scrie-ne direct pe WhatsApp.</p>';
    }

    function slotsFor(d) {
      var out = [];
      var now = new Date();
      var minTime = new Date(now.getTime() + cfg.lead * 3600 * 1000);
      for (var m = cfg.open * 60; m + cfg.step <= cfg.close * 60; m += cfg.step) {
        var t = new Date(d.getFullYear(), d.getMonth(), d.getDate(), Math.floor(m / 60), m % 60);
        if (t < minTime) continue;
        out.push(pad(Math.floor(m / 60)) + ':' + pad(m % 60));
      }
      return out;
    }

    function pickDay(btn) {
      [].forEach.call(daysEl.children, function (b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');
      sel.day = btn.getAttribute('data-iso');
      sel.time = null;
      renderSlots();
      update();
    }

    function renderSlots() {
      slotsEl.innerHTML = '';
      var p = sel.day.split('-');
      var list = slotsFor(new Date(+p[0], +p[1] - 1, +p[2]));
      if (!list.length) {
        slotsEl.innerHTML = '<p class="shb__empty">Nu mai sunt intervale în ziua asta. Alege altă zi.</p>';
        return;
      }
      list.forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'shb__slot';
        b.textContent = t;
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          [].forEach.call(slotsEl.children, function (x) { if (x.setAttribute) x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          sel.time = t;
          update();
        });
        slotsEl.appendChild(b);
      });
    }

    function frumos(iso) {
      var p = iso.split('-');
      var d = new Date(+p[0], +p[1] - 1, +p[2]);
      return ZILE[d.getDay()] + ' ' + d.getDate() + ' ' + LUNI[d.getMonth()];
    }

    function update() {
      var gata = !!(sel.day && sel.time);
      goEl.setAttribute('aria-disabled', gata ? 'false' : 'true');
      if (sumEl) {
        sumEl.innerHTML = gata
          ? 'Ai ales: <span>' + frumos(sel.day) + ', ora ' + sel.time + '</span>'
          : 'Alege o zi și o oră.';
      }
      if (gata && cfg.phone) {
        var msg = 'Bună! Vreau o programare la showroomul din Oradea pentru o potrivire ergonomică, '
                + frumos(sel.day) + ' la ora ' + sel.time + '. Mă numesc ';
        goEl.href = 'https://wa.me/' + cfg.phone + '?text=' + encodeURIComponent(msg);
      } else {
        goEl.removeAttribute('href');
      }
    }

    buildDays();
    root.setAttribute('data-ready', 'true');
  }

  function boot() {
    document.querySelectorAll('[data-shb]').forEach(function (el) {
      if (!el.hasAttribute('data-ready')) init(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
